// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content {
  --background: #f6f1ef;
}

.close-icon {
  margin: 0px;
  background: var(--color-white-accent);
  width: 35px;
  height: 35px;
  padding: 0px;
  z-index: 99;
}
.close-icon ion-icon {
  width: 100%;
  height: 100%;
  margin: 0px;
}
.close-icon:hover {
  background: #f2dbd9;
}

.hero {
  color: var(--color-black);
  text-align: left;
}
.hero p {
  font-family: AppFontLight, sans-serif;
  color: var(--color-black);
  font-size: 14px;
  margin-top: 5px;
  margin-bottom: 15px;
}

.search-bar ion-input {
  color: var(--color-black) !important;
  background: #FFFFFF;
}

.search-bar {
  border-radius: 26px;
  --inner-padding-end: 0px;
}

.search-bar > div {
  height: 100%;
  display: flex;
  flex-direction: row;
  place-items: center;
  margin-left: 8px;
}

.start-icon {
  margin-inline-end: 12px;
}

.search-container {
  padding: 0px 20px;
}
@media (min-width: 991px) {
  .search-container {
    padding: 0px 30px;
  }
}

.search-container ion-col {
  padding: 0 !important;
  border-radius: var(--ion-border-radius);
}

.no-place {
  padding: 16px 9px;
  font-family: AppFont-bold, sans-serif;
  background: #FFFFFF;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: var(--ion-border-radius);
  font-size: 12px;
  line-height: 131.5%;
}

.suggested-place {
  border-top: 0.5px solid var(--color-black);
  border-bottom: 0.5px solid var(--color-black);
  place-items: center;
  padding: 8px 10px;
  margin-top: 15px;
  text-align: left;
  padding: 10px 20px;
}
@media (min-width: 991px) {
  .suggested-place {
    padding: 10px 30px;
  }
}
.suggested-place .navigate-icon {
  margin-right: 15px;
  fill: var(--ion-color-primary) !important;
  width: 15px;
}
.suggested-place .actual-position-title {
  font-size: 14px;
  line-height: 17px;
  text-transform: uppercase;
  color: var(--color-black);
  font-family: AppFontSemiBold, sans-serif;
}
.suggested-place .wrapper-icon {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.suggested-place .actual-position {
  font-size: 13px;
  margin-top: 5px;
  line-height: 16px;
  color: var(--color-black);
  text-transform: uppercase;
  font-family: AppFontMedium, sans-serif;
}

#buttonContainer {
  position: absolute;
  width: 100%;
  bottom: 0;
}

.vertical-space-around {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
}

.cnt-btn {
  width: 100%;
  padding: 15px;
  text-align: center;
  font-family: AppFontMedium, sans-serif;
  color: white;
  letter-spacing: 0.075em;
  text-transform: uppercase;
  cursor: pointer;
  margin: 0;
  background: var(--ion-color-primary);
  border-radius: 50px;
  font-size: 15px;
}
@media (min-width: 991px) {
  .cnt-btn {
    margin: auto;
  }
}

.geo-btn {
  background: #62ABA4;
  font-family: AppFont-bold, sans-serif;
  color: #ffffff;
  font-weight: bold;
  cursor: pointer;
  width: 100%;
  padding: 16px;
  text-align: center;
  letter-spacing: 0.075em;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
}
.geo-btn ion-icon {
  width: 22px;
  height: 25px;
  margin-right: 10px;
}
@media (min-width: 991px) {
  .geo-btn {
    width: 600px;
    margin: auto;
  }
}

.heading-text {
  font-size: 19px;
  color: var(--ion-text-color);
  font-weight: 500;
  line-height: 145%;
  margin: 20px 0 10px;
}
.heading-text.desktop {
  display: block;
}
@media (max-width: 992px) {
  .heading-text.desktop {
    display: none;
  }
}
.heading-text.mobile {
  display: none;
}
@media (max-width: 992px) {
  .heading-text.mobile {
    display: block;
  }
}

.sub-heading {
  font-size: 18px;
  line-height: 134%;
  margin: 0;
}

.footer-btn {
  font-family: AppFontBold, sans-serif;
  text-transform: uppercase;
  color: white;
}

ion-footer {
  background: var(--color-background-alt) !important;
  width: 100%;
}

.footer-btn {
  background: unset;
  padding: 0 28px 26px !important;
  box-shadow: none;
}
.footer-btn .button {
  flex: 1;
  background: var(--ion-color-primary) !important;
  color: white !important;
  text-align: center;
}
.footer-btn .button:first-child {
  margin-right: 3px;
}
.footer-btn .button:last-child {
  margin-left: 3px;
}
.footer-btn .button.active {
  transition: 0.3s linear;
  background: var(--ion-color-main);
  color: var(--ion-text-color);
}
.footer-btn .button.active:hover {
  transition: 0.3s linear;
  background: var(--ion-color-main);
}

.desktop {
  display: none;
  margin: 50px 25px;
}
@media (min-width: 991px) {
  .desktop {
    display: block;
  }
}
.desktop .hero {
  background: white;
  border: 0.5px solid #E5E5E5;
  box-shadow: 0px 4px 10px rgba(33, 33, 33, 0.02);
  border-radius: 10px;
}

.mobile {
  display: none;
}
@media (max-width: 992px) {
  .mobile {
    display: block;
  }
}

.logo-block {
  width: 100%;
  display: flex;
  justify-content: center;
}
.logo-block ion-img {
  width: 76px;
}
@media (max-width: 992px) {
  .logo-block {
    display: none;
  }
}

@media (min-width: 991px) {
  .desktop-hero {
    text-align: center;
  }
}

.pac-container {
  width: 100%;
  padding: 8px 20px !important;
  margin-top: 5px;
  border-radius: 16px !important;
  border: none !important;
  border-radius: 26px;
}
.pac-container .pac-item {
  border-top: none !important;
  font-family: AppFontMedium, sans-serif;
  padding: 16px 0;
  line-height: 1 !important;
  font-size: 14px !important;
  color: var(--color-black);
  display: flex;
  cursor: pointer;
  justify-content: space-between;
  border-bottom: 0.3px solid var(--color-black);
  text-align: left;
}
.pac-container .pac-item:last-child {
  border-bottom: none;
}
.pac-container .pac-item .pac-matched {
  font-family: AppFontBold, sans-serif;
}

.cross_icon {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  position: absolute;
  top: 20px;
  right: 15px;
}
.cross_icon ion-img {
  width: 25px;
  height: 25px;
}

.suche ion-button {
  --border-radius: 26px;
  fill: white;
  height: 100%;
  min-width: 100px;
}
@media (max-width: 992px) {
  .suche ion-button {
    min-width: 80px;
  }
}

.delivery-title {
  font-size: 20px;
  text-align: center;
  font-family: AppFontBold, sans-serif;
  text-transform: uppercase;
  margin: 50px 0px 25px;
}

.end-icon {
  margin-right: 25px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/check-delivery-radius-modal/check-delivery-radius-modal.component.scss"],"names":[],"mappings":"AAaA;EACE,qBAAA;AAZF;;AAeA;EAIE,WAAA;EACA,qCAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,WAAA;AAfF;AAgBE;EACI,WAAA;EACA,YAAA;EACA,WAAA;AAdN;AAgBE;EACI,mBAAA;AAdN;;AAkBA;EAEE,yBAAA;EACA,gBAAA;AAhBF;AAqBE;EACE,qCAAA;EACA,yBAAA;EACA,eAAA;EACA,eAAA;EACA,mBAAA;AAnBJ;;AAuBA;EACE,oCAAA;EACA,mBAAA;AApBF;;AAuBA;EAEE,mBAAA;EACA,wBAAA;AArBF;;AAwBA;EACE,YAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;AArBF;;AAuBA;EACE,uBAAA;AApBF;;AAsBA;EACE,iBAAA;AAnBF;AAxDE;EA0EF;IAGI,iBAAA;EAjBF;AACF;;AAoBA;EACE,qBAAA;EACA,uCAAA;AAjBF;;AAoBA;EACE,iBAAA;EACA,qCAAA;EACA,mBAAA;EACA,yCAAA;EACA,uCAAA;EACA,eAAA;EACA,mBAAA;AAjBF;;AAoBA;EACE,0CAAA;EACA,6CAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;AAjBF;AAtFE;EAgGF;IASI,kBAAA;EAfF;AACF;AAgBE;EACE,kBAAA;EACA,yCAAA;EACA,WAAA;AAdJ;AAiBE;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,wCAAA;AAfJ;AAiBE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;AAfJ;AAiBE;EACE,eAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;EACA,sCAAA;AAfJ;;AAqBA;EACE,kBAAA;EACA,WAAA;EACA,SAAA;AAlBF;;AAqBA;EACE,YAAA;EACA,aAAA;EACA,sBAAA;EACA,6BAAA;EACA,mBAAA;AAlBF;;AAqBA;EACE,WAAA;EACA,aAAA;EACA,kBAAA;EACA,sCAAA;EACA,YAAA;EAEA,uBAAA;EACA,yBAAA;EACA,eAAA;EACA,SAAA;EACA,oCAAA;EACA,mBAAA;EACA,eAAA;AAnBF;AAjJE;EAuJF;IAeI,YAAA;EAjBF;AACF;;AAoBA;EACE,mBAAA;EACA,qCAAA;EACA,cAAA;EACA,iBAAA;EACA,eAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AAjBF;AAmBE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;AAjBJ;AA3KE;EA0KF;IAsBI,YAAA;IACA,YAAA;EAjBF;AACF;;AAoBA;EACE,eAAA;EACA,4BAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAjBF;AAmBE;EACE,cAAA;AAjBJ;AAtLE;EAsMA;IAGI,aAAA;EAfJ;AACF;AAkBE;EACE,aAAA;AAhBJ;AA9LE;EA6MA;IAGI,cAAA;EAdJ;AACF;;AAkBA;EACE,eAAA;EACA,iBAAA;EACA,SAAA;AAfF;;AAkBA;EACE,oCAAA;EACA,yBAAA;EACA,YAAA;AAfF;;AAkBA;EACE,kDAAA;EACA,WAAA;AAfF;;AAkBA;EACE,iBAAA;EACA,+BAAA;EACA,gBAAA;AAfF;AAqBE;EACE,OAAA;EACA,+CAAA;EACA,uBAAA;EACA,kBAAA;AAnBJ;AAqBI;EACE,iBAAA;AAnBN;AAsBI;EACE,gBAAA;AApBN;AAuBI;EACE,uBAAA;EACA,iCAAA;EACA,4BAAA;AArBN;AAuBM;EACE,uBAAA;EACA,iCAAA;AArBR;;AA0BA;EACE,aAAA;EAKA,iBAAA;AA3BF;AA1PE;EA+QF;IAGI,cAAA;EApBF;AACF;AAuBE;EACE,iBAAA;EACA,2BAAA;EACA,+CAAA;EACA,mBAAA;AArBJ;;AAwBA;EACE,aAAA;AArBF;AAnQE;EAuRF;IAGI,cAAA;EAnBF;AACF;;AAqBA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;AAlBF;AAmBE;EACE,WAAA;AAjBJ;AAjRE;EA6RF;IAQI,aAAA;EAhBF;AACF;;AA5RE;EA8SF;IAEI,kBAAA;EAfF;AACF;;AAsBA;EAEE,WAAA;EACA,4BAAA;EACA,eAAA;EACA,8BAAA;EACA,uBAAA;EACA,mBAAA;AApBF;AAsBE;EACE,2BAAA;EACA,sCAAA;EACA,eAAA;EACA,yBAAA;EACA,0BAAA;EACA,yBAAA;EACA,aAAA;EACA,eAAA;EACA,8BAAA;EACA,6CAAA;EACA,gBAAA;AApBJ;AAqBI;EACE,mBAAA;AAnBN;AAsBI;EACE,oCAAA;AApBN;;AAwBA;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;AArBF;AAsBE;EACE,WAAA;EACA,YAAA;AApBJ;;AAwBE;EACE,qBAAA;EACA,WAAA;EACA,YAAA;EACA,gBAAA;AArBJ;AA5UE;EA6VA;IAMI,eAAA;EAnBJ;AACF;;AAsBA;EACE,eAAA;EAEA,kBAAA;EAEE,oCAAA;EACA,yBAAA;EACA,qBAAA;AArBJ;;AAwBA;EACE,kBAAA;AArBF","sourcesContent":["@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content;\n  }\n}\n\n\nion-content {\n  --background: #f6f1ef;\n}\n\n.close-icon {\n\n\n\n  margin: 0px;\n  background: var(--color-white-accent);\n  width: 35px;\n  height: 35px;\n  padding: 0px;\n  z-index: 99;\n  ion-icon {\n      width: 100%;\n      height: 100%;\n      margin: 0px;\n  }\n  &:hover {\n      background: #f2dbd9;\n  }\n}\n\n.hero {\n\n  color: var(--color-black);\n  text-align: left;\n  // @include mobile {\n  //   padding: 20px;\n  // }\n\n  p {\n    font-family: AppFontLight, sans-serif;\n    color: var(--color-black);\n    font-size: 14px;\n    margin-top: 5px;\n    margin-bottom: 15px;\n  }\n}\n\n.search-bar ion-input {\n  color: var(--color-black) !important;\n  background: #FFFFFF;\n\n}\n.search-bar {\n\n  border-radius: 26px;\n  --inner-padding-end: 0px;\n}\n\n.search-bar > div {\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  place-items: center;\n  margin-left: 8px;\n}\n.start-icon{\n  margin-inline-end: 12px;\n}\n.search-container {\n  padding: 0px 20px;\n  @include desktop {\n    padding: 0px 30px;\n  }\n\n}\n.search-container ion-col {\n  padding: 0 !important;\n  border-radius: var(--ion-border-radius);\n}\n\n.no-place {\n  padding: 16px 9px;\n  font-family: AppFont-bold, sans-serif;\n  background: #FFFFFF;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  border-radius: var(--ion-border-radius);\n  font-size: 12px;\n  line-height: 131.5%;\n}\n\n.suggested-place {\n  border-top: 0.5px solid var(--color-black);\n  border-bottom: 0.5px solid var(--color-black);\n  place-items: center;\n  padding: 8px 10px;\n  margin-top: 15px;\n  text-align: left;\n  padding: 10px 20px;\n  @include desktop() {\n    padding: 10px 30px;\n  }\n  .navigate-icon {\n    margin-right: 15px;\n    fill: var(--ion-color-primary) !important;\n    width: 15px;\n  }\n\n  .actual-position-title {\n    font-size: 14px;\n    line-height: 17px;\n    text-transform: uppercase;\n    color: var(--color-black);\n    font-family: AppFontSemiBold, sans-serif;\n  }\n  .wrapper-icon {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n  }\n  .actual-position {\n    font-size: 13px;\n    margin-top: 5px;\n    line-height: 16px;\n    color: var(--color-black);\n    text-transform: uppercase;\n    font-family: AppFontMedium, sans-serif;\n\n  }\n}\n\n\n#buttonContainer {\n  position: absolute;\n  width: 100%;\n  bottom: 0;\n}\n\n.vertical-space-around {\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-around;\n  align-items: center;\n}\n\n.cnt-btn {\n  width: 100%;\n  padding: 15px;\n  text-align: center;\n  font-family: AppFontMedium, sans-serif;\n  color: white;\n\n  letter-spacing: 0.075em;\n  text-transform: uppercase;\n  cursor: pointer;\n  margin: 0;\n  background: var(--ion-color-primary);\n  border-radius: 50px;\n  font-size: 15px;\n  @include desktop {\n    margin: auto;\n  }\n}\n\n.geo-btn {\n  background: #62ABA4;\n  font-family: AppFont-bold, sans-serif;\n  color: #ffffff;\n  font-weight: bold;\n  cursor: pointer;\n  width: 100%;\n  padding: 16px;\n  text-align: center;\n  letter-spacing: 0.075em;\n  text-transform: uppercase;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  ion-icon {\n    width: 22px;\n    height: 25px;\n    margin-right: 10px;\n  }\n\n  @include desktop {\n    width: 600px;\n    margin: auto;\n  }\n}\n\n.heading-text {\n  font-size: 19px;\n  color: var(--ion-text-color);\n  font-weight: 500;\n  line-height: 145%;\n  margin: 20px 0 10px;\n\n  &.desktop {\n    display: block;\n    @include mobile() {\n      display: none;\n    }\n  }\n\n  &.mobile {\n    display: none;\n    @include mobile() {\n      display: block;\n    }\n  }\n}\n\n.sub-heading {\n  font-size: 18px;\n  line-height: 134%;\n  margin: 0;\n}\n\n.footer-btn {\n  font-family: AppFontBold, sans-serif;\n  text-transform: uppercase;\n  color: white;\n}\n\nion-footer{\n  background:   var(--color-background-alt) !important;\n  width: 100%;\n}\n\n.footer-btn {\n  background: unset;\n  padding: 0 28px 26px !important;\n  box-shadow: none;\n  @include desktop {\n    // margin: 0px 50px 0 !important;\n    // width: calc(100% - 100px) !important;\n  }\n\n  .button {\n    flex: 1;\n    background: var(--ion-color-primary) !important;\n    color: white !important;\n    text-align: center;\n\n    &:first-child {\n      margin-right: 3px;\n    }\n\n    &:last-child {\n      margin-left: 3px;\n    }\n\n    &.active {\n      transition: 0.3s linear;\n      background: var(--ion-color-main);\n      color: var(--ion-text-color);\n\n      &:hover {\n        transition: 0.3s linear;\n        background: var(--ion-color-main)\n      }\n    }\n  }\n}\n.desktop {\n  display: none;\n  @include desktop() {\n    display: block;\n  }\n\n  margin: 50px 25px;\n  .hero {\n    background: white;\n    border: 0.5px solid #E5E5E5;\n    box-shadow: 0px 4px 10px rgba(33, 33, 33, 0.02);\n    border-radius: 10px;\n  }\n}\n.mobile {\n  display: none;\n  @include mobile() {\n    display: block;\n  }\n}\n.logo-block {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  ion-img {\n    width: 76px;\n  }\n  @include mobile {\n    display: none;\n  }\n}\n.desktop-hero {\n  @include desktop() {\n    text-align: center;\n    // margin:15px 15px;\n  }\n\n}\n// .cross {\n//   fill: var(--ion-color-primary) !important;\n// }\n.pac-container {\n\n  width: 100%;\n  padding: 8px 20px !important;\n  margin-top: 5px;\n  border-radius: 16px !important;\n  border: none !important;\n  border-radius: 26px;\n\n  .pac-item {\n    border-top: none !important;\n    font-family: AppFontMedium, sans-serif;\n    padding: 16px 0;\n    line-height: 1 !important;\n    font-size: 14px !important;\n    color: var(--color-black);\n    display: flex;\n    cursor: pointer;\n    justify-content: space-between;\n    border-bottom: 0.3px solid var(--color-black);\n    text-align: left;\n    &:last-child {\n      border-bottom: none;\n    }\n\n    .pac-matched {\n      font-family: AppFontBold, sans-serif;\n    }\n  }\n}\n.cross_icon {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end; \n  position: absolute;\n  top: 20px;\n  right: 15px;\n  ion-img {\n    width: 25px;\n    height: 25px;\n  }\n}\n.suche {\n  ion-button {\n    --border-radius: 26px;\n    fill: white;\n    height: 100%;\n    min-width: 100px;\n    @include mobile {\n      min-width: 80px\n    }\n  }\n}\n.delivery-title {\n  font-size: 20px;\n\n  text-align: center;\n\n    font-family: AppFontBold, sans-serif;\n    text-transform: uppercase;\n    margin: 50px 0px 25px;\n\n}\n.end-icon {\n  margin-right: 25px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
